"use client";

import { i18nKey } from "@/lib/react/i18n/types/locale";
import React from "react";

export type SortBy = "contest_end_date" | "start_date" | "group_name";
export type SortOrder = "asc" | "desc";

type Props = {
  t: (key: i18nKey) => string;
  sortBy: SortBy;
  sortOrder: SortOrder;
  onChange: (next: { sortBy: SortBy; sortOrder: SortOrder }) => void;
  onCommit?: () => void;
};

export const ContestSortSection: React.FC<Props> = ({
  t,
  sortBy,
  sortOrder,
  onChange,
  onCommit,
}) => {
  return (
    <div className="space-y-2">
      <p className="px-2 text-xs">{t("Sort")}</p>
      {/* 並び替え対象 */}
      <div className="rounded-2xl border border-white/15 bg-white/5 overflow-hidden">
        <select
          data-testid="sort-by-select"
          value={sortBy}
          onChange={(e) => {
            const nextBy = e.target.value as SortBy;
            onChange({ sortBy: nextBy, sortOrder });
            onCommit?.();
          }}
          className="
        block w-full
        bg-transparent text-white/90 outline-none
        px-2 py-2
        appearance-none
        cursor-pointer
      "
        >
          <option value="group_name">{t("Name")}</option>
          <option value="start_date">{t("Event period start date")}</option>
          <option value="contest_end_date">{t("Event period end date")}</option>
        </select>
      </div>

      {/* 昇順/降順 */}
      <div className="rounded-2xl border border-white/15 bg-white/5 overflow-hidden">
        <select
          data-testid="sort-order-select"
          value={sortOrder}
          onChange={(e) => {
            const nextOrder = (e.target.value === "asc" ? "asc" : "desc") as SortOrder;
            onChange({ sortBy, sortOrder: nextOrder });
            onCommit?.();
          }}
          className="
        block w-full
        bg-transparent text-white/90 outline-none
        px-2 py-2
        appearance-none
        cursor-pointer
      "
        >
          <option value="desc">{t("Descending")}</option>
          <option value="asc">{t("Ascending")}</option>
        </select>
      </div>
    </div>
  );
};